module.exports = __webpack_public_path__ + "static/media/book_overlay.e614e204.png";